import { get } from 'lodash/fp';

import { notify } from 'components/Notification';
import {
  createFavoriteRemovedNotifierComponent,
  createFavoriteAddedNotifierComponent,
  createDislikeAdNotificationComponent,
  createDislikeAdRemovalNotificationComponent,
  createCopyToClipboardNotificationComponent,
} from '../toastComponents';

const NOTIFICATION_TIMEOUT = 5000;
const NOTIFICATION_POSITION_BOTTOM_LEFT = 'bottom-left';

const toastComponents = {
  copyToClipboard: createCopyToClipboardNotificationComponent,
};

export const sendRemovedFavoriteNotification = (adTitle) => {
  notify.dismiss();
  notify.info(createFavoriteRemovedNotifierComponent({ adTitle }), {
    autoClose: NOTIFICATION_TIMEOUT,
    hideProgressBar: true,
    position: NOTIFICATION_POSITION_BOTTOM_LEFT,
  });
};

export const sendRemovedDislikeNotification = (adTitle) => {
  notify.dismiss();
  notify.info(createDislikeAdRemovalNotificationComponent({ adTitle }), {
    autoClose: NOTIFICATION_TIMEOUT,
    hideProgressBar: true,
    position: NOTIFICATION_POSITION_BOTTOM_LEFT,
  });
};

export const sendAddedFavoriteNotification = (adTitle) => {
  notify.dismiss();
  notify.info(createFavoriteAddedNotifierComponent({ adTitle }), {
    autoClose: NOTIFICATION_TIMEOUT,
    hideProgressBar: true,
    position: NOTIFICATION_POSITION_BOTTOM_LEFT,
  });
};

export const sendDislikeAdNotification = (adTitle) => {
  notify.dismiss();
  notify.info(createDislikeAdNotificationComponent({ adTitle }), {
    autoClose: NOTIFICATION_TIMEOUT,
    hideProgressBar: true,
    position: NOTIFICATION_POSITION_BOTTOM_LEFT,
  });
};

export const sendNotification = (name, options = {}) => {
  const toastComponent = get([name], toastComponents);

  if (toastComponent) {
    notify.dismiss();
    notify.info(toastComponent(options), {
      autoClose: NOTIFICATION_TIMEOUT,
      hideProgressBar: true,
      position: NOTIFICATION_POSITION_BOTTOM_LEFT,
    });
  }
};
